<template>
  <div>
    <ClearPhoneNoDialog :type-fix="clearPhoneNumDialog.typeForFixButton" :show="clearPhoneNumDialog.isShow"
                        :pageName="clearPhoneNumDialog.pageName" @dialogClose="clearDialogClose"></ClearPhoneNoDialog>
    <ApplyShowDetailDrawer :drawer-title="drawerTitle" :areaMap="areaMap" :phoneNumShow="phoneNumShow" ref="applyDetailDrawer"/>

    <div class="manage-table">
      <div class="search-box">
        <el-form label-width="70px " :model="formSearch" size="mini" class="demo-form-inline" label-position="left">
          <el-form-item :label="`${employeeShowName}`">
            <el-input v-model="formSearch.employeeName" :placeholder="`请输入员工姓名`"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="访客姓名">
            <el-input v-model="formSearch.visitorName" placeholder="请输入访客姓名" clearable></el-input>
          </el-form-item>

          <el-form-item label="日期范围">
            <el-date-picker
                class="my-date-picker"
                v-model="formSearch.dateArea"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
            </el-date-picker>
          </el-form-item>

          <div class="button-area">
            <span>
                 <el-button type="primary" @click="onSearchClick" size="mini">查询</el-button>
                <el-button type="success" plain @click="onResetSearch" size="mini">重置</el-button>
            </span>
            <span>
            <el-button type="danger" plain size="mini" style="margin-left: 50px" @click="cleartextShow('访客记录')">
              明文查看
            </el-button>

            <el-button type="warning" plain size="mini" @click="exportData"> 数据导出</el-button>
            </span>
          </div>
        </el-form>


        <el-form label-width="70px " :model="formSearch" size="mini" class="demo-form-inline" label-position="left">
          <el-form-item label="员工工号">
            <el-input v-model="formSearch.employeeWorkId" placeholder="请输入员工工号" clearable></el-input>
          </el-form-item>
          <el-form-item label="访客手机">
            <el-input v-model="formSearch.visitorPhoneNo" placeholder="请输入访客手机" clearable></el-input>
          </el-form-item>

          <el-form-item label="时间范围">
            <el-time-picker style="margin-right: 10px"
                            class="my-time-select"
                            placeholder="起始时间"
                            value-format="HH:mm"
                            format="HH:mm"
                            :picker-options="pickerOptions"
                            v-model="formSearch.startTime">
            </el-time-picker>
            <el-time-picker
                class="my-time-select"
                placeholder="结束时间"
                v-model="formSearch.endTime"
                value-format="HH:mm"
                format="HH:mm"
                :picker-options="pickerOptions">
            </el-time-picker>
          </el-form-item>
        </el-form>

        <el-form label-width="70px " :model="formSearch" size="mini" class="demo-form-inline" label-position="left">
          <el-form-item label="员工部门">
            <el-select v-model="formSearch.department" :placeholder="`请选择部门`"
                       :popper-append-to-body="false" value-key="id" clearable>
              <el-option :value="selectTree" class="setstyle" style="overflow: auto; height: 100%" disabled
                         :key="selectTree.id" :label="selectTree.name">
                <el-tree style="min-height: 150px; max-height: 300px" :data="customerList" :props="defaultProps"
                         ref="tree"
                         check-strictly :expand-on-click-node="false"
                         @node-click="(data, node, item) => addAdminHandleNodeClick(data, node, item)"></el-tree>
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="到访情况">
            <el-select class="my-select" v-model="formSearch.visitStatus" size="mini" clearable>
              <el-option v-for="item in searchArea.visitStatus" :key="item.value" :label="item.label"
                         :value="item.value"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="拜访区域">
            <el-select v-model="formSearch.areaName" :placeholder="`请选择拜访区域`"
                       :popper-append-to-body="false" value-key="id" clearable>
              <el-option :value="selectArea" class="setstyle" style="overflow: auto; height: 100%" disabled
                         :key="selectArea.id" :label="selectArea.name">
                <el-tree style="min-height: 150px; max-height: 300px" :data="allAreaTree" :props="areaProps"
                         ref="tree"
                         check-strictly :expand-on-click-node="false"
                         @node-click="(data, node, item) => addAreaNodeClick(data, node, item)"></el-tree>
              </el-option>
            </el-select>
          </el-form-item>

        </el-form>
      </div>
      <el-table stripe class="right-desc" border :data="tableData" size="mini">
        <el-table-column v-for="(headerItem) in mainTableHeader" :key="headerItem.prop" :prop="headerItem.prop"
                         :label="headerItem.label" :width="headerItem.width">
          <template v-slot="scope">
            <template v-if="headerItem.type === 0">{{ scope.row[headerItem.prop] }}</template>
            <template v-else-if="headerItem.type === 1">
              {{ scope.row[headerItem.prop] | tableDateFilter(headerItem.prop) }}
            </template>
            <el-tag v-else-if="headerItem.type === 2">{{
                scope.row[headerItem.prop] | tableDateFilter(headerItem.prop)
              }}
            </el-tag>
            <template v-else-if="headerItem.type === 9">
              <template v-if="phoneNumShow">
                {{ scope.row[headerItem.prop] }}
              </template>
              <template v-else>
                {{ scope.row[headerItem.prop] | phNoFilter }}
              </template>
            </template>
            <template v-else-if="headerItem.type > 100">
              <el-button v-if="(headerItem.type % 100) & 1" type="primary" size="mini"
                         @click="tableShow(scope.row)">查看
              </el-button>
              <el-button v-if="(headerItem.type % 100) & 2" type="warning" size="mini"
                         @click="tableEdit(scope.row)">编辑
              </el-button>
              <el-button v-if="(headerItem.type % 100) & 4" type="danger" size="mini"
                         @click="tableDelete(scope.row)">删除
              </el-button>
            </template>
            <template v-else> {{ scope.row[headerItem.prop] }}</template>
          </template>
        </el-table-column>
      </el-table>
      <div class="pager">
        <el-pagination layout="sizes, prev, pager, next, jumper" :total="totalCount" :page-sizes="pageSizes"
                       :page-size.sync="curPageSize" :pager-count="5"
                       :current-page.sync="curPageIndex" @size-change="handleSizeChange"
                       @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>

  </div>
</template>

<script>
import {mixin_clearPhoneNumShow, mixin_page_table} from '@/utils/mixin'
import {getAllDepartment,} from '@/api/organize-api'
import ClearPhoneNoDialog from "@/components/ClearPhoneNoDialog.vue";
import {getApproveList, getFormData,} from "@/api/apply-api";
import {getAllArea} from "@/api/device-manager-api";
import ApplyShowDetailDrawer from "@/components/ApplyShowDetailDrawer.vue";
import ExcelJS from "exceljs";
import {getSettingItem} from "@/api/setting-api";

export default {
  components: {ApplyShowDetailDrawer, ClearPhoneNoDialog},
  props: ['visitType'],
  mixins: [mixin_page_table, mixin_clearPhoneNumShow],

  data() {
    return {
      icHidden: false,
      // type 定义：
      // 0，数据不需要处理
      // 1，数据需要过滤，使用 tableDateFilter
      // 2. 数据需要加标签并过滤，使用 tableDateFilter
      // 100. 添加 button ，规则：对100 取余，
      //          结果二进制第1位代表 查看 button， 点击调用 tableShow
      //          结果二进制第2位代表 编辑 button， 点击调用 tableEdit
      //          结果二进制第3位代表 删除 button， 点击调用 tableDelete
      mainTableHeader: [],

      employeeShowName: "",

      customerList: [],
      allAreaTree: [],
      areaMap: {},
      employeeList: [],
      departmentMap: {},
      defaultProps: {
        children: "departments",
        label: "name",
      },
      areaProps: {
        children: "areas",
        label: "name",
      },
      selectTree: "",
      selectArea: "",

      pickerOptions: {
        selectableRange: '00:00:00-23:59:59', // 设置可选的时间范围
        format: 'HH:mm' // 设置时间显示格式
      },
      formSearch: {
        employeeName: "",
        employeeWorkId: "",
        department: "",
        areaName: "",
        areaId: "",
        selectDepartment: "",
        visitorName: "",
        visitorPhoneNo: "",
        visitStatus: "",
        dateArea: [],
        startTime: "",
        endTime: "",
      },

      searchEnsureParam: {},

      searchArea: {
        visitStatus: [
          {value: "ALL", label: "全部"},
          {value: "NO", label: "未到"},
          {value: "ENTER", label: "已到"},
        ],
      },

      drawerTitle: "",

      areaConfig: {
        areaLimit: false,
        areaIdList: [],
      }
    }
  },

  mounted() {
    // 身份证字段显隐（预约+邀约任一配置为不展示则全端隐藏）
    Promise.all([
      getSettingItem("VISITORINFO", "VISITOR_BOOK"),
      getSettingItem("VISITORINFO", "VISITOR_INVITE"),
    ]).then(([bookRes, inviteRes]) => {
      const readHidden = (res) => {
        if (res.data.code === 200 && res.data.data && res.data.data.length > 0) {
          try {
            const content = JSON.parse(res.data.data[0].content || "{}")
            return content && content.idCardNo === 1
          } catch (e) {
            return false
          }
        }
        return false
      }
      this.icHidden = readHidden(bookRes) || readHidden(inviteRes)
    }).catch(err => {
      console.log("load visitor field setting err", err)
    })
    getAllArea().then(({data}) => {
      console.log("getAllArea result =>", data)
      this.allAreaTree = data.data
      data.data.forEach(item => {
        this.areaMap[item.id] = item
        ;(item.areas || []).forEach(area => {
          this.areaMap[area.id] = area
        })
      })
      this.tableData.forEach(item => {
        this.$set(item, "param15", item.entryArea ? this.areaMap[item.entryArea].name : "")
      })
      if (this.$store.state.roleType === "COMMON") {
        this.areaConfig = {
          areaLimit: true,
          areaIdList: [],
        }
        let myAreaIds = this.visitType === "subscribe" ? this.$store.state.myApplyAreaIds : this.$store.state.myArriveAreaIds
        myAreaIds.forEach(item => {
          let area = this.areaMap[item]
          this.areaConfig.areaIdList.push(area.id)
          ;(area.areas || []).forEach(subArrea => {
            this.areaConfig.areaIdList.push(subArrea.id)
          })
        })

        let myAreaList = []
        data.data.forEach(area => {
          let find = this.areaConfig.areaIdList.find(item => item === area.id)
          if (find) {
            myAreaList.push(area)
          }
        })
        this.allAreaTree = myAreaList
      } else {
        this.areaConfig = {
          areaLimit: false,
          areaIdList: [],
        }
      }
      this.searchEnsureParam = this.getSearchParams()
      this.initTableStruct()
      this.refreshTableData()

    }).catch(err => {
      console.log("getAllArea err =>", err)
      this.showNetErrMsg();
      this.initTableStruct()
      this.refreshTableData()
    })

    if (this.visitType === "subscribe") {
      this.drawerTitle = "预约记录详情"
      this.employeeShowName = "预约员工"
    } else if (this.visitType === "invite") {
      this.drawerTitle = "邀约记录详情"
      this.employeeShowName = "邀约员工"
    } else {
      console.error("VisitInfo", "mounted with type unknown", this.visitType);
    }

    getAllDepartment().then(({data}) => {
      console.log("getAllDepartment result =>", data)
      this.customerList = data.data
      if (data.code === 200) {
        this.saveEmployeeToMap(data.data)
      }
    }).catch(err => {
      console.log("getAllDepartment err =>", err)
      this.showNetErrMsg();
    })

  },// end of mounted

  methods: {

    saveEmployeeToMap(employeeList) {
      employeeList.forEach(item => {
        this.departmentMap[item.id] = item
        if (item.departments && item.departments.length > 0) {
          this.saveEmployeeToMap(item.departments)
        }
      })
    },

    initTableStruct() {
      if (this.visitType === "subscribe") {
        this.mainTableHeader = [
          {prop: 'param1', label: '预约员工', type: 0},
          {prop: 'param2', label: '员工部门', type: 0},
          {prop: 'param3', label: '员工工号', type: 0},
          {prop: 'param4', label: '访客姓名', type: 0},
          {prop: 'param5', label: '访客手机', type: 9, width: 130},
          // {prop: 'param15', label: '到访区域', type: 0, width: 150},
          {prop: 'param8', label: '开始时间', type: 0, width: 150},
          {prop: 'param9', label: '结束时间', type: 0, width: 150},
          {prop: 'param12', label: '审核状态', type: 2, width: 90},
          {prop: 'param13', label: '是否到访', type: 2, width: 90},
          {prop: 'param14', label: '操作', type: 101, width: 80},
        ]

      } else if (this.visitType === "invite") {
        this.mainTableHeader = [
          {prop: 'param1', label: '邀约员工', type: 0},
          {prop: 'param2', label: '员工部门', type: 0},
          {prop: 'param3', label: '员工工号', type: 0},
          {prop: 'param4', label: '访客姓名', type: 0},
          {prop: 'param5', label: '访客手机', type: 9, width: 130},
          // {prop: 'param15', label: '到访区域', type: 0, width: 150},
          {prop: 'param8', label: '开始时间', type: 0, width: 150},
          {prop: 'param9', label: '结束时间', type: 0, width: 150},
          {prop: 'param12', label: '审核状态', type: 2, width: 90},
          {prop: 'param13', label: '是否到访', type: 2, width: 90},
          {prop: 'param14', label: '操作', type: 101, width: 80},
        ]
      } else {
        console.error("VisitInfo", "mounted with type unknown", this.visitType);
      }
    },

    refreshTableData() {
      this.tableData = []

      const postData = {
        type: this.visitType === "subscribe" ? "BOOK_APPLY" : "INVITE_APPLY",
        current: this.curPageIndex,
        size: this.curPageSize,
      }
      let topDeptIds = this.$store.state.myApplyDepartmentIds
      if (topDeptIds && topDeptIds.length > 0) {
        postData.topDeptIds = topDeptIds
      }
      const searchParam = Object.assign(postData, this.searchEnsureParam)

      getApproveList(searchParam).then(({data}) => {
        console.log("getApproveList get data ", data);
        if (data.code !== 200) {
          this.showServerErrMsg(data.msg)
          return
        }
        if (data.data == null) {
          return
        }

        this.totalCount = data.data.totals

        data.data.data.forEach(item => {
          let department = this.departmentMap[item.departmentId]
          let departmentName = department ? department.name : item.employee ? item.employee.departmentName : ""
          let areaName = ""
          if (item.entryArea) {
            let area = this.areaMap[item.entryArea]
            let superArea = area ? this.areaMap[area.parentId] : null
            areaName = superArea && area ? superArea.name + "，" + area.name : ""
          }
          this.tableData.push({
            data: item,
            param1: item.employee ? item.employee.name : "",
            param2: departmentName,
            param3: item.employee ? item.employee.workId : "",
            param4: item.visitor ? item.visitor.name : "",
            param5: item.visitor ? item.visitor.tel : "",
            param8: `${item.beginDate} ${item.beginTime.substr(0, 5)}`,
            param9: `${item.endDate} ${item.endTime.substr(0, 5)}`,
            param12: item.state,
            param13: item.arrived,
            param15: areaName
          })
        });
      }).catch(err => console.log("getApproveList err", err))
    },

    tableShow(rowData) {
      this.$refs.applyDetailDrawer.showApplyDetail(rowData.data)
    },

    onSearchClick() {


      this.searchEnsureParam = this.getSearchParams()
      this.curPageIndex = 1
      this.refreshTableData()
    },

    getAllSelectDepartmentIds(selectDepartment, saveArr) {
      saveArr.push(selectDepartment.id)
      if (selectDepartment.departments && selectDepartment.departments.length > 0) {
        for (let i = 0; i < selectDepartment.departments.length; i++) {
          this.getAllSelectDepartmentIds(selectDepartment.departments[i], saveArr)
        }
      }
    },

    getSearchParams() {
      console.log("getSearchParams 000 ", this.formSearch.department, this.formSearch.selectDepartment)
      let params = {}
      if (this.formSearch.employeeName) {
        params.employeeName = this.formSearch.employeeName
      }
      if (this.formSearch.employeeWorkId) {
        params.employeeWorkId = this.formSearch.employeeWorkId
      }
      if (this.formSearch.visitorName) {
        params.visitorName = this.formSearch.visitorName
      }
      if (this.formSearch.visitorPhoneNo) {
        params.visitorTel = this.formSearch.visitorPhoneNo
      }

      if (this.formSearch.department && this.formSearch.selectDepartment) {
        params.departmentIds = []
        this.getAllSelectDepartmentIds(this.formSearch.selectDepartment, params.departmentIds)
      }

      if (this.formSearch.visitStatus && this.formSearch.visitStatus !== "ALL") {
        params.arrived = this.formSearch.visitStatus
      }
      if (this.formSearch.dateArea && this.formSearch.dateArea.length > 1) {
        params.beginDate = this.formSearch.dateArea[0]
        params.endDate = this.formSearch.dateArea[1]
      }
      if (this.formSearch.startTime || this.formSearch.endTime) {
        params.beginTime = this.formSearch.startTime ? this.formSearch.startTime + ":00" : "00:00:00"
        params.endTime = this.formSearch.endTime ? this.formSearch.endTime + ":59" : "23:59:59"
      }
      if (this.formSearch.areaName) {
        let area = this.areaMap[this.formSearch.areaId]
        if (area.parentId === -1) {
          params.entryAreaIds = (area.areas || []).map(item => item.id)
        } else {
          params.entryAreaIds = [area.id]
        }
      } else {
        if (this.areaConfig.areaLimit) {
          params.entryAreaIds = this.areaConfig.areaIdList
        }
      }
      return params
    },

    onResetSearch() {
      this.formSearch = {
        employeeName: "",
        employeeWorkId: "",
        department: "",
        selectDepartment: "",
        visitorName: "",
        visitorPhoneNo: "",
        areaName: "",
        areaId: "",
        visitStatus: "",
        dateArea: [],
        startTime: "",
        endTime: "",
      }
      this.searchEnsureParam = {}
      this.curPageIndex = 1
      this.refreshTableData()
    },

    addAdminHandleNodeClick(e) {
      console.log(e);
      this.formSearch.department = e.name;
      this.formSearch.selectDepartment = e;
    },

    addAreaNodeClick(e) {
      console.log(e);
      this.formSearch.areaName = e.name;
      this.formSearch.areaId = e.id;
    },

    checkExportDatePass() {
      if (this.formSearch.dateArea.length === 0) {
        this.$message.error("请选择日期范围")
        return false
      }
      // 日期不能超过一年
      let startDate = new Date(this.formSearch.dateArea[0])
      let endDate = new Date(this.formSearch.dateArea[1])
      let diff = endDate - startDate
      if (diff > 366 * 24 * 3600 * 1000) {
        this.$message.error("日期范围不能超过一年")
        return false
      }

      return true

    },
    async exportData() {
      if (!this.checkFixButtonPass()) {
        return
      }
      if (!this.checkExportDatePass()) {
        return
      }
      let apiType

      if (this.visitType === "subscribe") {
        apiType = "BOOK_APPLY"
      } else if (this.visitType === "invite") {
        apiType = "INVITE_APPLY"
      }

      let formsResponse = await getFormData(apiType)
      if (formsResponse.data.code !== 200) {
        this.showServerErrMsg(formsResponse.data.msg)
        return
      }
      let formList = formsResponse.data.data.formItems

      let formNameList = []
      formNameList.push({title: "被访员工", valueGetter: (item) => item.employee ? item.employee.name : ""})
      formNameList.push({title: "员工部门", valueGetter: (item) => item.employee ? item.employee.departmentName : ""})
      formNameList.push({title: "员工手机", valueGetter: (item) => item.employee ? item.employee.tel : ""},)
      formNameList.push({title: "员工邮箱", valueGetter: (item) => item.employee ? item.employee.email : ""},)

      formNameList.push({title: "访客姓名", valueGetter: (item) => item.visitor.name})
      formNameList.push({title: "访客手机", valueGetter: (item) => item.visitor.tel})
      if (!this.icHidden) {
        formNameList.push({title: "访客证件", valueGetter: (item) => item.visitor.ic})
      }
      formNameList.push({title: "访客邮箱", valueGetter: (item) => item.visitor.email})
      formNameList.push({title: "访客地址", valueGetter: (item) => item.visitor.address})
      formNameList.push({title: "访客单位", valueGetter: (item) => item.visitor.company})
      formNameList.push({
        title: "到访区域", valueGetter: (item) => {
          return item.entryArea ? this.areaMap[item.entryArea].name : ""
        }
      })

      formList.forEach(formItem => {
        formNameList.push({
          title: formItem.title, valueGetter: (item) => {
            if (item.forms == null) {
              return ""
            }
            if (formItem.name === "startTime") {
              return `${item.beginDate} ${item.beginTime.substr(0, 5)}`
            }
            if (formItem.name === "endTime") {
              return `${item.endDate} ${item.endTime.substr(0, 5)}`
            }
            let find = item.forms.find(form => form.name === formItem.name)
            return find ? find.value : ""
          }
        })
      })

      formNameList.push({
        title: "创建时间",
        valueGetter: (item) => `${item.createTime.substr(0, 10)} ${item.createTime.substr(11, 8)}`
      })
      formNameList.push({
        title: "审核状态", valueGetter: (item) => {
          return this.$options.filters.tableDateFilter(item.state, 'param12')
        }
      })
      formNameList.push({
        title: "是否到访", valueGetter: (item) => {
          return this.$options.filters.tableDateFilter(item.arrived, 'param13')
        }
      })

      await this.doExportRecordV2(formNameList)
    },

    async doExportRecordV2(formNameList) {
      console.log("doExportRecord", formNameList)
      let columnsSize = formNameList.length
      const workbook = new ExcelJS.Workbook()
      const sheet = workbook.addWorksheet('Sheet1');
      let headerList = this.getHeader(formNameList)
      sheet.addRow(headerList);
      const firstRow = sheet.getRow(1);
      firstRow.eachCell((cell, colNumber) => {
        cell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: {argb: 'FFD9D9D9'},
          bgColor: {argb: 'FFD9D9D9'}
        };
        cell.font = {
          size: 12,
          bold: true
        };
      });
      sheet.getRow(1).height = 20
      for (let i = 0; i < columnsSize; i++) {
        sheet.getColumn(i + 1).width = 12;
      }

      const postData = {
        type: this.visitType === "subscribe" ? "BOOK_APPLY" : "INVITE_APPLY",
        current: 1,
        size: 100,
      }
      let searchEnsureParam = this.getSearchParams()
      const searchParam = Object.assign(postData, searchEnsureParam)
      let pageMax = 10000

      while (searchParam.current <= pageMax) {
        try {
          console.log("download getApproveList start " + searchParam)
          let result = await getApproveList(searchParam);
          searchParam.current++;

          console.log("download getApproveList result ", result)

          if (result.data.code !== 200 || !result.data.data || !result.data.data.data || result.data.data.data.length === 0) {
            // 如果结果不符合条件，写入Excel文件并退出
            continue;
          }
          pageMax = result.data.data.pages

          // 处理数据
          result.data.data.data.forEach(item => {
            if (item.visitor == null) {
              // 跳过脏数据
              return
            }
            let rowData = this.getRowData(formNameList, item);
            sheet.addRow(rowData);
          });

          // 更新搜索参数并继续获取数据
          console.log("download getApproveList start " + searchParam.current)
        } catch (err) {
          searchParam.current++;
        }
      }

      // 导出 Excel 文件
      await this.finalDownloadV2(workbook);
    },

    async finalDownloadV2(workbook) {
      console.log("finalDownloadV2")
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      if (this.visitType === "subscribe") {
        link.download = '预约记录.xlsx';
      } else if (this.visitType === "invite") {
        link.download = '邀约记录.xlsx';
      } else {
        link.download = '记录.xlsx';
      }
      link.click();
      URL.revokeObjectURL(link.href);
    },

    getHeader(formNameList) {
      let header = []
      formNameList.forEach(item => {
        header.push(item.title)
      })
      return header
    },
    getRowData(formNameList, item) {
      let rowData = []
      formNameList.forEach(formItem => {
        rowData.push(formItem.valueGetter(item))
      })
      return rowData
    },

  },


  filters: {
    tableDateFilter(value, prop) {
      if (prop === "param12") {
        switch (value) {
          case 'PROCESS':
            return "审批中"
          case 'PASS':
            return '已通过'
          case 'REJECT':
            return '已拒绝'
          case 'CANCEL':
            return '已撤销'
          case 'NONE':
            return '审批中'
          default:
            return value
        }
      } else if (prop === "param13") {
        switch (value) {
          case 'NO':
            return "未到访"
          case 'ENTER':
            return '已到访'
          case 'LEAVE':
            return '已离开'
          default:
            return value
        }
      } else {
        return value
      }
    },
  }

}
</script>

<style lang="less" scoped>
.manage-table {
  height: calc(100vh - 200px);

  .right-desc {
    max-height: calc(100vh - 350px);
    overflow-y: auto;
  }
}


.el-input {
  width: calc(100% - 50px);
}

.search-box {
  padding: 20px;
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: start;

  .demo-form-inline {
    width: 33%;

    .el-input {
      width: calc(100% - 50px);
    }

    .el-select {
      width: calc(100%);
    }

    .my-date-picker {
      width: calc(100% - 50px);
    }

    .my-time-select {
      width: calc(50% - 30px);
    }

    .button-area {
      display: flex;
      flex-direction: row;
      justify-content: start;
      align-items: center;
      margin-top: 10px;

    }

    //background-color: red;
  }

}

/deep/ .el-form-item--mini.el-form-item {
  margin-bottom: 10px;
}

.my-date-picker /deep/ .el-range-separator {
  min-width: 22px;
}
</style>
